export enum LocationLevel {
  SINGLE = 'single',
  GROUP = 'group'
}